var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenRoundTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 30C55 43.8063 43.8063 55 30 55C16.1937 55 5 43.8063 5 30C5 16.1937 16.1937 5 30 5C43.8063 5 55 16.1937 55 30Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2525 18.2524L26.25 35.2487L19.2475 28.2512L15.7512 31.7474L26.25 42.2512L46.7475 21.7487L43.2525 18.2524Z",
    fill: "#CCFF90"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRoundTick);
export default __webpack_public_path__ + "static/media/green-round-tick.a0105f3b96a12acc4d6ab1c1213a0d42.svg";
export { ForwardRef as ReactComponent };